import React from "react";
import ReactJoyride, { CallBackProps, Step } from "react-joyride";
import { useTheme } from "@mui/material/styles";
import TourTooltip from "./TourTooltip";

interface TourProps {
  steps: Step[];
  run: boolean;
  callback: (data: CallBackProps) => void;
  stepIndex?: number;
  continuous?: boolean;
}

const Tour: React.FC<TourProps> = ({
  steps,
  run,
  callback,
  stepIndex,
  continuous = true,
}) => {
  const theme = useTheme();

  return (
    <ReactJoyride
      steps={steps}
      run={run}
      stepIndex={stepIndex}
      continuous={continuous}
      showSkipButton
      showProgress
      disableOverlayClose
      callback={callback}
      tooltipComponent={TourTooltip}
      scrollDuration={100}
      scrollOffset={120}
      styles={{
        options: {
          zIndex: 10000,
          primaryColor: theme.palette.primary.main,
          textColor: theme.palette.text.primary,
        },
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.4)",
        },
        spotlight: {
          borderRadius: 12,
        },
      }}
      floaterProps={{
        disableAnimation: false,
      }}
      locale={{
        last: "Let's Go", // Customize last button text if needed
      }}
    />
  );
};

export default Tour;
